import { BaseFilterListRequestModel } from "api/baseFilterListModel/BaseFilterListRequestModel";

export class PackageListRequestModel extends BaseFilterListRequestModel {
  simType?: string;
  constructor(data?: {
    name?: string;
    code?: string;
    page?: number;
    service?: string;
    limit?: number;
    simType?: string;
    order?: string;
  }) {
    super();
    this.code = data?.code;
    this.name = data?.name;
    this.simType = data?.simType;
    this.service = data?.service;
    this.order = data?.order;
    this.page = data?.page;
    this.limit = data?.limit;
  }
}
